/**
 * ShareLinkButton — copies the current page URL (including query params) to the clipboard.
 */

import React, { useState, useCallback } from 'react';
import { copyShareableLink } from '../utils/urlState.js';

export default function ShareLinkButton({ className = 'btn ghost sm' }) {
  const [copied, setCopied] = useState(false);

  const onCopy = useCallback(async () => {
    try {
      await copyShareableLink();
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }, []);

  return (
    <button
      type="button"
      className={className}
      onClick={onCopy}
      title="Copy link to this view"
      aria-label="Copy link to this view"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
      {copied ? 'Link copied' : 'Copy link'}
    </button>
  );
}
